const SIZES = ["XS", "S", "M", "L", "XL"];

export default SIZES;
